// ============================================================================
// Combat State - Client-side combat mode management
// ============================================================================

import { signal } from '@preact/signals';

// ============================================================================
// State
// ============================================================================

// Fight mode is a client-side toggle that determines right-click behavior
// When enabled, right-click directly attacks targets instead of opening context menu
export const isFightModeEnabled = signal<boolean>(false);

// ============================================================================
// Actions
// ============================================================================

// Toggle fight mode (client-side only, affects right-click behavior)
export const toggleFightMode = (): void => {
  isFightModeEnabled.value = !isFightModeEnabled.value;
};

// Set fight mode explicitly
export const setFightMode = ({ enabled }: { enabled: boolean }): void => {
  isFightModeEnabled.value = enabled;
};
